import React, {Component} from 'react';
import {Button, Form, Header, Icon, Popup, Grid, Message,ButtonGroup,Segment,Image} from 'semantic-ui-react';
import {CollapsiblePanel, Toggle} from '../universal/collapsiblePanel';
import GroupsListView from "./groups_list";
import {DropzoneComponent} from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import ReportContainer from "../../containers/report_container";
import Loader from '../universal/loader';
import {deleteImageFromReport, submitReport} from "../../data/report_api";
import AddNewDataToReport from "./add_new_data";
import {REPORT_ACTIONS_API_URL} from "../../constants/api_routes";
import {isSessionExpiringSoon} from "../../utils/validate_session_expiry";
import COTranscriptionSticky from "./co_transcription_sticky";
import SpeechInput from './speech_input';
import * as unavailable from "../../assets/photo_unavailable.jpg";
import AdditionalRoomPhotos from "../report/additional_room_photos"


const uuidv1 = require('uuid/v1');

class RoomsListView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            attachments: [],
            showEdit: undefined,
            deleteCalled: false,
            roomName: undefined,
            roomSaved: false,
            error: false,
            infoMessage: undefined,
            unsaved: false,
            additionalNotes: undefined,
            isSaveTemplateOpen: false,
            isExpanded: false,
            speechInput:false
        };
    }


     cloneWithoutImages = (data) => {
    if (Array.isArray(data)) {
        return data.map(item => this.cloneWithoutImages(item));
    } else if (data && typeof data === 'object') {
        const clone = {};
        for (const key in data) {
        if (key === 'image') continue; // skip only the heavy field
        clone[key] = this.cloneWithoutImages(data[key]);
        }
        return clone;
    }
    return data;
    };
    handleReportSubmit = async () => {
  try {
      if (isSessionExpiringSoon()){
            this.props.showPasswordWindow(true);
            return;
        }
        this.setState({ isSaving: true });
        let reportType = this.props.reportDetails['inspection_type'];

        const reportTypes = {"ci": "ci", "co": "co", "inv/ci": "ci", "inv": "ci","sng":"ci"};
        let reportUpdateRooms = this.cloneWithoutImages(this.props.reportUpdates.rooms);
        for (let i = 0; i < reportUpdateRooms.length; i++) {
            reportUpdateRooms[i].groups = [];
            let roomImages = reportUpdateRooms[i].images;
            for (let j = 0; j < roomImages.length; j++) {
                roomImages[j].image = undefined
            }
            reportUpdateRooms[i].images = roomImages;
        }
        let reportUpdateGroups = this.cloneWithoutImages(this.props.reportUpdates.groups);
        for (let i = 0; i < reportUpdateGroups.length; i++) {
            reportUpdateGroups[i].items = [];
        }
        let reportUpdateItems = this.cloneWithoutImages(this.props.reportUpdates.items);
        for (let i = 0; i < reportUpdateItems.length; i++) {
            let itemImages = reportUpdateItems[i].images;
            for (let j = 0; j < itemImages.length; j++) {
                itemImages[j].image = undefined
            }
            reportUpdateItems[i].images = itemImages;
        }

        const reportUpdateApiData = {
            report_id: this.props.reportUpdates['report_id'],
            rooms: reportUpdateRooms,
            groups: reportUpdateGroups,
            items: reportUpdateItems
        };
     const response = await submitReport(
      this.props.other_template ? 'both' : reportTypes[reportType],
      reportUpdateApiData
    );
            if (response.success) {
                this.props.initUploadImages(true);
                this.setState({roomSaved: true, infoMessage: "Successfully Saved!",isSaving:false});
                this.props.resetReportUpdateObject();

      if (this.props.mediaAttachments.length < 1) {
        this.props.getReportById(REPORT_ACTIONS_API_URL, this.props.reportId);
      }
      setTimeout(() => this.setState({ roomSaved: false }), 10000);
    } else {

      this.props.logErrorResponse(undefined, `Error Saving Rooms - ${response.statusMessage} ${JSON.stringify(this.cloneWithoutImages(this.props.reportUpdates))}`);
      this.setState({
        roomSaved: false,
        infoMessage: 'Error Saving!!',
        error: true,
        isSaving: false,
      });
     if (response.statusMessage) {
        const msg = response.statusMessage.toLowerCase();
        if (msg.includes("no data") || msg.includes("401") || msg.includes("unauthorized")) {
            console.log("checked success");
            this.props.showPasswordWindow(true);
        }
    }
     window.alert("Error saving, check error message")
      setTimeout(() => this.setState({ roomSaved: false, error: false }), 5000);
    }
  } catch (e) {
    // Handles network errors, logic errors, or unexpected runtime issues
        let errorMsg = `Copy / Paste and send to accounts@hinchpm.com the text of the following error ${e.message} ${(e.stack || '')} ${JSON.stringify(this.cloneWithoutImages(this.props.reportUpdates))} `;
    this.props.logErrorResponse(errorMsg)
    this.setState({
      roomSaved: false,
      infoMessage: errorMsg,
      isSaving: false,
      error: true,
    });
      window.alert("Error saving, check error message")
  }
};


    removeRoomImage = (r_i,file) => {
        this.removingFileSpeech(file)
                                if (file.id) {
                                    deleteImageFromReport(file.id).then((res) => { }); }
                                     this.props.removeMediaFromReport(r_i,-1,-1,file)
                            }
    removingFile = (file) => {
        let attachments = this.state.attachments;

        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }

        return attachments;
    };

    removingFileSpeech = (file) => {
        let attachments = [...this.state.attachments]

        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        this.setState({attachments:attachments})
    };
    updateRoomDetails = (roomIndex, room) => {
        if (!room.action) {
            room['action'] = 'update';
        }
        if (this.props.reportDetails['inspection_type'] === 'co') {
            room['additional_notes'] = this.state.additionalNotes;
            room['name'] = this.state.roomName;
        }
        else {
            room['name'] = this.state.roomName;
        }
        this.props.updateRoomInReport(roomIndex, room);
        this.setState({showEdit: undefined});
    };

    open = () => this.setState({showConfirm: true});
    close = () => this.setState({showConfirm: false});

    nextOverlayImage = (stepAmount = 1) =>{
        const index = this.props.overlayImageList.findIndex(img => img.id === this.props.overlayImage.id);
        if (index !== -1 && (index + stepAmount < this.props.overlayImageList.length - 1)) {
            this.props.setSelectedOverlayImage(this.props.overlayImageList[index + stepAmount]);
        }
        else { this.props.setSelectedOverlayImage(this.props.overlayImageList[this.props.overlayImageList.length - 1]);}
    }

    previousOverlayImage = (stepAmount = 1) =>{
        const index = this.props.overlayImageList.findIndex(img => img.id === this.props.overlayImage.id);
        if (index !== -1 && (index - stepAmount > 0)) {
            this.props.setSelectedOverlayImage(this.props.overlayImageList[index - stepAmount]);
        } else {
            this.props.setSelectedOverlayImage(this.props.overlayImageList[0]);
        }
    }
    jumpToItem= (itemNumber) => {
        let clientId = undefined
        let itemCounter = 0
        this.props.rooms.map(room=>{
            room.groups.map(group =>{
                group.items.map(item =>{
                    itemCounter++
                    if (itemCounter == itemNumber) {
                        clientId = item["client_id"]
                        let jumpLoc = document.getElementById(clientId)
                    }
                })
            })
        })
        if(!this.state.isExpanded){
            this.setState({isExpanded:true})
                setTimeout(()=>{ 
                    let jumpLoc = document.getElementById(clientId)
                    if(jumpLoc) {
                        jumpLoc.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }},200)
                 } else {
                    let jumpLoc = document.getElementById(clientId)
                    if(jumpLoc) {
                        jumpLoc.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }
            }
            useOverlayImage = (r_i,g_i,i_i,fileData) => {
                const url = fileData.file;
                const extension = url.split('.').pop().split('?')[0].toLowerCase();

                let mimeType = 'image/jpeg'; // default
                if (extension === 'png') mimeType = 'image/png';
                if (extension === 'jpg' || extension === 'jpeg') mimeType = 'image/jpeg';

                const filename = `${fileData.id}.${extension}`;
                const client_id = uuidv1();


                    const dummyBlob = new Blob([""], { type: "image/png" });
                    const dummyFile = new File([dummyBlob],filename, {
                        type: "image/png",
                    });
                    dummyFile.dataURL = url
                let imageObj = {
                    additionalImgId:fileData.id,
                    id:client_id,
                    file: dummyFile,
                    image_path: url,
                };
                this.props.addNewMediaIntoReport(r_i, g_i, i_i, imageObj);

                this.nextOverlayImage(1);
                };
    render() {

        // if(this.props.reportUpdates.rooms.length +this.props.reportUpdates.groups.length +this.props.reportUpdates.items.length > 0) {
        window.onbeforeunload = function() { return "Do you want to close this tab?"; }
        // } else {
        //     window.onbeforeunload = undefined
        // }
        const rooms = this.props.rooms;
        return (<div>
               {this.state.showSelection === 'cotranscription' && <COTranscriptionSticky jumpToItem={this.jumpToItem}></COTranscriptionSticky>}
            <Header textAlign="left" className="pad-top">Rooms {this.state.roomSaved &&
            <span className="info-success">Saved!</span>} {this.state.error &&
            <span className="info-danger">Error Saving! Check above for full error message</span>}
            {this.props.reportUpdates.rooms.length +this.props.reportUpdates.groups.length +this.props.reportUpdates.items.length > 0 &&<span style={{color:"red"}}>Not Saved</span>}
                <Button primary
                    disabled={(this.props.reportDetails['ci_image_count'] == 0 && this.props.reportDetails["report_type"] != "other")} compact
                    negative={(this.props.reportDetails['ci_image_count'] == 0 && this.props.reportDetails["report_type"] != "other")}
                    content={(this.props.reportDetails['ci_image_count'] == 0 && this.props.reportDetails["report_type"] != "other") ? <span><Icon name="warning"></Icon>UNABLE TO SAVE - NO CI IMAGES DETECTED, LOAD A VALID CI REPORT (CLICK THE LOAD DATA FROM PREVIOUS REPORTS BUTTON ON THE TOP LEFT, SELECT THE LATEST REPORT, THEN CLICK LOAD REPORT BUTTON) </span> : "Save"}
                    className="pull-right"
                    onClick={this.handleReportSubmit}
                />
                <Icon name={this.state.isExpanded ?"compress":"expand"} className="icon-button pull-right" size='large'
                      color='grey' onClick={()=>{this.setState({isExpanded:!this.state.isExpanded})}}/>
                      {this.props.reportDetails['inspection_type'] == "co" &&
                      <Icon name="sound" className="icon-button pull-right" size='large'
                      color='grey' onClick={()=>{this.setState({showSelection:"cotranscription"})}}/>}
{this.props.roomErrorResponse &&
            <Message error className="info-danger">{this.props.roomErrorResponse}</Message>}
            </Header>
            {!this.props.rooms && <Loader/>}
            {this.state.isSaving && <Loader save={true}/>}
            {!(this.props.reportDetails['ci_image_count'] == 0 && this.props.reportDetails["report_type"] != "other")  &&<CollapsiblePanel>
                {this.props.rooms && !this.state.speechInput ? rooms.map((room, i) => {
                    function preloadImages(dropzone) {
                        (room.images || []).forEach(function (i) {
                            const name = i.id;
                            let file = {url: i['image_path'], name: name, size: 1000000, id: name};
                            let imageUrl = i['image_path'];
                            if (i.image) {
                                file = i.image.file;
                                imageUrl = i.image.file.dataURL;
                            }

                            file['serverId'] = name;
                            file['accepted'] = true;
                            file['status'] = 'success';
                            file['upload'] = {
                                progress: 100,
                                total: 100000,
                                bytesSent: 100000
                            };
                            dropzone.files.push(file);
                            console.log["imageULR",imageUrl]
                            dropzone.emit("addedfile", file);
                            dropzone.emit("thumbnail", file, imageUrl);
                            dropzone.emit("complete", file);
                        });
                    }

                    let dropZone = null;
                    const componentConfig = {postUrl: 'no-url'};

                    let djsConfig = {
                        autoProcessQueue: false,
                        addRemoveLinks: true,
                        acceptedFiles: "image/*",
                    };

                    
                    const eventHandlers = {
                        init: (dropzone) => {
                            dropZone = dropzone;
                            dropZone.autoDiscover = false;
                            preloadImages(dropzone);
                        },
                        addedfile: (file) => {
                            let imageObj = {
                                id: file.upload.uuid,
                                file: file,
                            };
                            const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
                            if (isMobile) {
                                alert("You are using a mobile device, do not add images directly using the dropboxes as they can be lost this way. Please take and add photos with the live camera/image overlay feature or use your phone's camera app to ensure they are saved to your camera roll.");
                            }
                            const isHeic = file.type === "image/heic" || file.type === "image/heif" || file.name.toLowerCase().endsWith(".heic") || file.name.toLowerCase().endsWith(".heif");

                            if (isHeic) {
                                dropZone.removeFile(file);
                                alert(`HEIC images are not supported. Please upload JPG or PNG. You can google HEIC to JPG to find free online conversion services. Also please set your iPhone image file type to Best Compatibilty. Change iPhone Settings for Future Photos: Go to Settings > Camera > Formats and select "Most Compatible" to ensure new photos are saved directly as JPG, avoiding the need for conversion later.
Convert on iPhone Using the Files App: Open the Photos app, select the HEIC photo(s), tap Share, then Copy. Open the Files app, go to "On My iPhone," create a new folder, long-press in the folder, and tap Paste. The pasted image will be in JPG format.
Convert on iPhone Using Email: Send the HEIC photo to yourself via the Mail app. The attachment will be automatically converted to JPG upon download.
Convert on Mac Using the Photos App: Open the Photos app, select the HEIC photos, go to File > Export > Export [number] Photos, choose "JPEG" as the format, and select a save location.
Use Online Converters: Websites like HEIC.online, Canva, and Cloudinary allow users to drag and drop HEIC files to convert them to JPG instantly, with options to adjust quality and remove metadata.`  );

                                return; 
                            }
                            if(file.upload.additionalImgId) {
                                imageObj.additionalImgId =  file.upload.additionalImgId
                                const dummyBlob = new Blob([""], { type: "image/png" });
                                const dummyFile = new File([dummyBlob], `${file.upload.additionalImgId}.png`, {
                                    type: "image/png",
                                });
                                imageObj.file = dummyFile;
                                if(file.upload.image_path) {
                                    imageObj.image_path =  file.upload.image_path 
                                    imageObj.file.dataURL = file.upload.image_path
                                }
                            }
                            this.props.addNewMediaIntoReport(i, -1, -1, imageObj);
                        },
                        removedfile: (file) => {
                            this.setState({attachments: this.removingFile(file)});
                            if (file.id) {
                                deleteImageFromReport(file.id).then((res) => {
                                });
                            }
                            else {
                                this.props.removeMediaFromReport(i,-1,-1,file)
                            }
                            this.props.removeMediaFromReport(i,-1,-1,file)
                        }
                    };
                    return <Toggle room={true} topAmt={55} key={room['client_id']} ref={room['client_id']} forceActive={this.state.isExpanded}
                                   title={<div className="field" style={{display: 'inline'}}>
                                       {this.state.showEdit === room['client_id'] &&
                                       <div className="ui input report-inputs" style={{width:'695px'}}>
                                           <Form onSubmit={() => {
                                               this.updateRoomDetails(i, room)
                                           }} style={{width:'100%'}}>
                                               <input style={{verticalAlign: 'middle'}} type="text"
                                                      defaultValue={room.name}
                                                      placeholder="Room Name"
                                                      autoFocus
                                                      maxLength="255"
                                                      onFocus={(e) => {
                                                          this.setState({roomName: e.target.value})
                                                      }}
                                                      onChange={(e) => {
                                                          this.setState({roomName: e.target.value})
                                                      }}
                                                      onBlur={() => {
                                                          if(this.state.roomName.length > 1){
                                                              this.setState({showEdit: undefined});
                                                              this.updateRoomDetails(i, room);
                                                          }
                                                      }}
                                                      required
                                               />
                                           </Form>
                                       </div>
                                       }
                                       {this.state.showEdit !== room['client_id'] &&
                                       <span className="report-field-name" onClick={(e) => {
                                           if (this.props.reportDetails['inspection_type'] !== 'co' || this.props.reportDetails['inspection_type'] === 'co'&& this.props.other_template) {
                                               this.setState({showEdit: room['client_id']})
                                           }
                                       }}>{room.name}</span>}
                                                                                   {this.props.reportDetails.inspection_type === 'co' && !this.props.other_template && room.ci_images && room.ci_images.length > 0 && (
                                            <Popup flowing hideOnScroll on="click" position="bottom right" trigger={<Button style={{marginTop:"-5px"}}content={`View CI Images (${room.ci_images.length})`} icon="image" className="pull-right" compact basic />}>
                                                <div style={{ maxWidth: 500, maxHeight: 400, overflowY: 'auto' }}>
                                                    <Image.Group size="small">
                                                        {room.ci_images.map((img, index) => (
                                                            <Image   onClick={() => window.open(img.image_path, '_blank', 'noopener,noreferrer')} key={index} src={img.image_path} bordered rounded style={{ margin: 5, cursor: 'pointer', maxHeight: 150, objectFit: 'cover' }} />
                                                        ))}
                                                    </Image.Group>
                                                </div>
                                            </Popup>
                                        )}
                                       {(this.props.reportDetails['inspection_type'] !== 'co' || this.props.reportDetails['inspection_type'] === 'co'&& this.props.other_template) &&
                                       <div style={{display: 'inline'}} className="pull-right">
                                           <Popup
                                               trigger={<Icon name="pin"
                                                              size='large'
                                                              aria-label="Save As Template"
                                                              color='grey'
                                               />}
                                               content={<Button positive content="Save as Template"
                                                                onClick={(e) => {
                                                                    this.setState({isSaveTemplateOpen: undefined});
                                                                    this.props.showSaveAsTemplate(true, room);
                                                                }}/>}
                                               on="click"
                                               onOpen={() => {
                                                   this.setState({isSaveTemplateOpen: room['client_id']})
                                               }}
                                               onClose={() => {
                                                   this.setState({isSaveTemplateOpen: undefined})
                                               }}
                                               position="left center"
                                               hideOnScroll
                                               open={this.state.isSaveTemplateOpen === room['client_id']}
                                           />
                                           <Popup
                                               trigger={<Icon name="trash"
                                                              size='large'
                                                              color='grey'
                                               />}
                                               content={<Button negative content="Confirm Delete Room?"
                                                                onClick={(e) => {
                                                                    this.props.deleteRoomFromReport(i);
                                                                    this.setState({deleteCalled: !this.state.deleteCalled})
                                                                }}/>}
                                               on="click"
                                               position="right center"
                                               hideOnScroll
                                               className="pad-left"
                                           />
                                       </div>}
                                   </div>}>
                      {!this.props.overlayImageList &&  <React.Fragment><Header>General View Photos</Header><DropzoneComponent key={room['client_id'] + '-' + i} config={componentConfig}
                                           eventHandlers={eventHandlers}
                                           djsConfig={djsConfig}/></React.Fragment>}
                                         {this.props.overlayImageList && <div style={{textAlign:"center",margin:"10px"}}>      
                                             {room.images.length > 0 && <Segment style={{display:"inline-block",marginBottom:"0px"}} attached="bottom"><Image.Group size="tiny" >{room.images.map(image => {
                                               let image_path = image.image_path || image.image && image.image.file.image_path || image.image && image.image.file.dataURL 
                                               return  <Popup key={image.id} trigger={<Image style={{borderRadius:"5px",  width:"auto", height:"100px",
                                               }} src={image_path || unavailable} />}
                                               content={<Button negative content="Confirm Delete Room Image??"  onClick={(e) => { this.removeRoomImage(i,image); }}/>}  on="click" position="right center" hideOnScroll className="pad-left"/>
                                               })}</Image.Group></Segment>}
                                            <ButtonGroup >
                                                        <Button icon onClick={()=>{this.previousOverlayImage(10)}}>
                                                            <Icon name='fast backward' />
                                                        </Button>
                                                        <Button icon onClick={()=>{this.previousOverlayImage(1)}}>
                                                            <Icon name='caret left' />
                                                        </Button>
                                                        <Button disabled={!this.props.overlayImage || (this.props.overlayImage && this.props.overlayImage.loading)} loading={this.props.overlayImage && this.props.overlayImage.loading} onClick={(()=>{this.useOverlayImage(i,-1,-1,this.props.overlayImage)})}
                                                            icon><Icon name="photo"></Icon> Add Selected Overlay Image</Button>
                                                        <Button  onClick={()=>{this.nextOverlayImage(1)}}  icon>
                                                            <Icon name='caret right' />
                                                        </Button>
                                                        <Button  onClick={()=>{this.nextOverlayImage(10)}}  icon>
                                                            <Icon name='fast forward' />
                                                        </Button>
                                                        </ButtonGroup>
                                           </div>}
                        <GroupsListView groups={room.groups} reportType={this.props.reportType} other_template={this.props.other_template}
                                        roomId={room['client_id']} roomIndex={i} reportId={this.props.reportId} forceActive={this.state.isExpanded}/>
                           <AdditionalRoomPhotos roomClientId={room.client_id}inspectionId={this.props.reportDetails['inspection_id']}></AdditionalRoomPhotos>             
                        {/* {this.props.reportType === 'co' &&
                        <div className="pad-top pad-bottom">
                            <Form>
                                <Form.Input fluid type="text"
                                            placeholder="Add Additional Notes"
                                            defaultValue={room['additional_notes']}
                                            label="Additional Note" icon="plus"
                                            onChange={(e) => {
                                                this.setState({additionalNotes: e.target.value})
                                            }}
                                            onFocus={(e) => {
                                                this.setState({additionalNotes: e.target.value})
                                            }}
                                            onBlur={() => {
                                                this.updateRoomDetails(i, room)
                                            }}
                                            iconPosition="left"/>
                            </Form>
                        </div>} ADDITTIONAL NOTE SECTION, REMOVED*/}
                    </Toggle>
                }) : null}
            </CollapsiblePanel>}
          <Grid stackable>
              { (this.props.reportDetails['inspection_type'] !== 'co' || this.props.reportDetails['inspection_type'] === 'co' && this.props.other_template ) &&  <Grid.Row>
                    <Grid.Column width={3}>
                        <div className='bottom-margin' style={{textAlign:"center"}}>
                            <Popup hideOnScroll content="Load Room Templates"trigger={<Button basic color="green" tabIndex="-1" icon style={{paddingBottom:'9px'}} onClick={()=>{this.props.showLoadFromTemplate(true)}} ><Icon name="open folder" size="large"/></Button>   }></Popup>                                                 
                    {(this.props.reportDetails['inspection_type'] != "co" || (this.props.reportDetails['inspection_type'] == "co" && this.props.reportDetails["report_type"] == "other")) && <React.Fragment>
                     <Popup hideOnScroll content="AI Transcription" trigger={   <Button basic color="orange" tabIndex="-1" icon style={{paddingBottom:'9px'}} onClick={()=>{this.props.openSelection("transcription")}} ><Icon name="sound" size="large"/></Button>}></Popup>
                     <Popup hideOnScroll content="Speech Input" trigger={    <Button  basic color="blue" tabIndex="-1" icon style={{paddingBottom:'9px'}} onClick={()=>{this.setState({speechInput:!this.state.speechInput},()=>{ setTimeout(() => {const listenButton = document.getElementById("listen-button");if (listenButton) { listenButton.scrollIntoView({ block: "center" });}}, 100);})}} ><Icon name="microphone" size="large"/></Button>}></Popup>
                        {/* <Button  tabIndex="-1" disabled={this.state.unsaved} icon style={{paddingBottom:'9px'}} onClick={()=>{this.props.openSelection("roomsort")}} ><Icon name="list" size="large"/></Button> */}
                    </React.Fragment>
                        }
                        </div>
                    </Grid.Column>
                    <Grid.Column width={12}>
                    {!this.state.speechInput && <AddNewDataToReport type='Room' reportId={this.props.reportId} other_template={this.props.other_template}/>}
                    </Grid.Column>
                </Grid.Row>}
{                this.props.reportDetails["inspection_type"] === "co" && !this.props.other_template && <Grid.Row><Button  tabIndex="-1" icon style={{paddingBottom:'9px',margin:"auto"}} onClick={()=>{this.setState({speechInput:!this.state.speechInput},()=>{ setTimeout(() => {const listenButton = document.getElementById("listen-button");if (listenButton) { listenButton.scrollIntoView({ block: "center" });}}, 100);})}} ><Icon name="microphone" size="large"/></Button></Grid.Row>}
               <Grid.Row>                {this.state.speechInput && <SpeechInput removingFileSpeech={this.removingFileSpeech} other_template={this.props.other_template}/>}</Grid.Row>
            </Grid> 
        </div>);
    }
}

export default ReportContainer(RoomsListView);


// WEBPACK FOOTER //
// ./src/views/report/rooms_list.js